import { useState } from 'react';
import styles from '../../shared/Page.module.css';

/** The invitation link, for when the email did not go: hand it over another way. */
export function CopyLink({ link, label = 'Copy the invitation link' }: { link: string; label?: string }) {
  const [copied, setCopied] = useState(false);
  return (
    <button
      type="button"
      className={styles.btn}
      onClick={() => {
        void navigator.clipboard?.writeText(link).then(() => setCopied(true)).catch(() => setCopied(false));
      }}
    >
      {copied ? 'Copied' : label}
    </button>
  );
}
